<div class="bg-primary-50 rounded-3xl h-full">
    <div class="p-3">
        <div class="flex justify-center items-center mb-2">
            <h2 class="text-primary-800 !mb-0">Steps</h2>
        </div>
        <ol>
            @for (step of steps; let i = $index; track step) {
                <li
                    class="pl-2 mb-1 p-2 flex justify-between items-center"
                    [ngClass]="{
                        'bg-primary-100 rounded-3xl':
                            currentStep?.title === step.title,
                    }"
                >
                    <div>
                        {{ i + 1 }}.
                        @if (step.url && canProceedDirectlyToStep) {
                            <button
                                type="button"
                                (click)="proceedToStep(step)"
                                [title]="step.sideNavigationTitle ?? step.title"
                            >
                                {{
                                    step.sideNavigationTitle ?? step.title
                                        | ellipsis
                                            : step.sideNavigationMaxLength ?? 17
                                }}
                            </button>
                        } @else {
                            {{
                                step.sideNavigationTitle ?? step.title
                                    | ellipsis
                                        : step.sideNavigationMaxLength ?? 17
                            }}
                        }
                    </div>

                    @if (!isApplicationTemplate()) {
                        @if (step.passedValidation === true) {
                            <img
                                src="assets/svg/check_icon.svg"
                                alt="Check Icon"
                            />
                        } @else if (step.passedValidation === false) {
                            <img
                                src="assets/svg/error_icon.svg"
                                alt="Error Icon"
                            />
                        }
                    }
                </li>
            }
        </ol>
    </div>
</div>
